<div class="services container" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
  <div *ngFor="let comp of serviceCategories">
    <ng-container [ngSwitch]="comp.type">
      <div *ngSwitchCase="'app-grid-service-cards'">
        <app-grid-service-cards
          [data]="comp"
          [language]="language"
        ></app-grid-service-cards>
      </div>
      <div *ngSwitchCase="'text-with-image'">
        <app-text-with-image
          [data]="comp"
          [language]="language"
          [fileName]="'service-page/' + comp.fileName"
        ></app-text-with-image>
      </div>
      <div *ngSwitchCase="'image-with-text'">
        <app-image-with-text
          [data]="comp"
          [language]="language"
          [fileName]="'service-page/' + comp.fileName"
        ></app-image-with-text>
      </div>
      <div *ngSwitchCase="'multi-text-with-image'">
        <app-multi-text-with-image
          [data]="comp.details"
          [language]="language"
          [fileName]="'service-page/' + comp.fileName"
        ></app-multi-text-with-image>
      </div>
    </ng-container>
  </div>
</div>

<!-- <div class="process-follow">
  <app-process-follow></app-process-follow>
</div> -->
